/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Vs_Excel_IntroInputs */

const en_gc_search_guides_gridcraft_vs_excel_intro = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose GridCraft when you want to explore an open-source spreadsheet with local files and a familiar grid. Choose an appropriate Excel edition when your work depends on established Excel workflows, shared Microsoft 365 documents or existing VBA. The deciding factor is the workbook and the people who need to use it.`)
};

const zh_gc_search_guides_gridcraft_vs_excel_intro = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如果你想尝试开源电子表格、使用本地文件并保留熟悉的网格操作，可以考虑 GridCraft。如果工作依赖成熟的 Excel 流程、Microsoft 365 共享文档或现有 VBA，则应选择支持这些需求的 Excel 版本。决定因素是你的工作簿，以及需要使用它的人。`)
};

/**
* | output |
* | --- |
* | "Choose GridCraft when you want to explore an open-source spreadsheet with local files and a familiar grid. Choose an appropriate Excel edition when your work..." |
*
* @param {Gc_Search_Guides_Gridcraft_Vs_Excel_IntroInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_vs_excel_intro = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Vs_Excel_IntroInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Vs_Excel_IntroInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_vs_excel_intro(inputs)
	return zh_gc_search_guides_gridcraft_vs_excel_intro(inputs)
});
export { gc_search_guides_gridcraft_vs_excel_intro as "gc.search_guides.gridcraft_vs_excel.intro" }